import * as R from "ramda";
import date from "locutus/php/datetime/date";


export const getDestinationLink=(hash="")=>`/user/login?destination=${window.location.pathname}${window.location.search}${hash ? `#${hash}`:""}`;

export const getSearchType = R.compose(
  R.last,
  R.reject(R.isEmpty),
  R.split("/"),
);
export const toggleFacet = (id, value, state) => {
  const stateArr = R.compose(R.map((n) => String(n)))(
    R.unnest([state?.[id] ? state[id] : []]),
  );
  return { [id]: R.symmetricDifference([String(value)], stateArr) };
};

export const getInjectable = (id) => {
  const markup = document.querySelector(id)?.innerHTML;
  document.querySelector(id)?.remove();
  return markup;
};

export const scrollToResults = (el) => {
  setTimeout(() => {
    const results = document.querySelectorAll(el)?.[0];
    if (!results) return false;
    results.scrollIntoView({
      alignToTop: true,
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    results.focus({ preventScroll: true });
  }, 1000);
};

const parseObj = R.compose((obj) =>
  R.map(
    R.applySpec({
      [`${obj.id}`]: R.prop("id"),
      name: R.prop("name"),
    }),
  )(R.prop("values", obj)),
);

const createItem = R.applySpec({
  label: (d, v) => R.compose(R.join(" "), R.pluck("name"))([d, v]),
  values: R.compose(R.dissoc("name"), R.dissoc("selected"), R.merge),
});

//returns array for rate board modal
export const parseOptions = (obj1, obj2) =>
  parseObj(obj1).flatMap((d) => parseObj(obj2).map((v) => createItem(d, v)));

export const getDate = (str) => {
  const d = new Date(str.replace(/-/g, "/"));
  return d.toLocaleDateString();
};

/**
 * metaParser should return an array of objects
 *
 * [
 *   {
 *     field_id: "field_content_type",
 *     label: "Content Type",
 *     url_alias: "content_type",
 *     values: [
 *       {
 *         raw_value: "411",
 *         url: "https:...",
 *         values: {
 *           value: "Press Release",
 *           count: 11,
 *         },
 *       },
 *     ],
 *   },
 * ]
 *
 */

// Return a new object with necessary fields or an empty array.
const applySpec = (arr, i) => {
  return R.not(R.isNil(arr))
    ? R.map(
        R.applySpec({
          raw_value: R.prop("raw_value"),
          value: R.path(["values", "value"]),
          count: R.path(["values", "count"]),
          active: R.pathOr("false", ["values", "active"]),
          facet_value: R.compose(
            R.concat(`${i.url_alias}:`),
            R.prop("raw_value"),
          ),
        }),
      )(arr)
    : [];
};

export const metaParser = (d) => {
  /* return empty if undefined */
  if (!d?.facets_metadata || !d?.facets) return [];
  const { facets_metadata, facets } = d;
  const meta = R.values(facets_metadata);
  // Merge the objects in this array into a single object
  const facetsObj = R.mergeAll([...R.flatten(facets)]);
  // build and return parsed facets
  return R.map((i) =>
    R.assoc("values", applySpec(facetsObj[i.field_id], i), i),
  )(meta);
};

// https://stackoverflow.com/questions/46880822/how-to-json-stringify-a-dom-element

const nullOrEmpty = (n) => R.either(R.isNil, R.isEmpty)(n.name);

export const getJSON = (node) =>
  R.compose(
    R.reject(R.either(R.isNil, R.isEmpty)),
    R.map(
      R.applySpec({
        id: R.prop("id"),
        className: R.prop("className"),
        attributes: R.prop("attributes"),
        dataset: R.prop("dataset"),
        name: R.prop("localName"),
        value: R.prop("nodeValue"),
        childNodes: R.compose(getJSON, R.prop("childNodes")),
      }),
    ),
  )(node);

export const lookupValueById = (prop, selected, items) => {
  //return the first matching item
  return R.filter(R.propEq(prop, String(selected)), items)[0]
    ? R.filter(R.propEq(prop, String(selected)), items)[0]
    : {};
};

export function keyDown(changes, state) {
  if (state.highlightedIndex < items.length - 1) {
    return {
      ...changes,
      isOpen: true,
      highlightedIndex: state.highlightedIndex + 1,
    };
  } else {
    return {
      ...changes,
    };
  }
}

export function keyUp(changes, state) {
  if (state.highlightedIndex >= 1) {
    return {
      ...changes,
      isOpen: true,
      highlightedIndex: state.highlightedIndex - 1,
    };
  } else {
    return {
      ...changes,
    };
  }
}

/**
 * Takes start and end Datetime objects and sets a format based upon the differences
 *
 * @param startDate
 * @param endDate
 *
 * @return mixed
 */
export function formatDates(startDate, endDate) {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const startYear = start.getYear();
  const endYear = end.getYear();
  const startMonth = start.getMonth();
  const endMonth = end.getMonth();
  const startDay = start.getDay();
  const endDay = end.getDay();
  // Same year and month, different day
  if (startYear === endYear && startMonth === endMonth && startDay !== endDay) {
    return `${date("F j", start)}-${date("j, Y", end)}`;
  }
  // Multi day, different months
  if (startYear === endYear && startMonth !== endMonth) {
    return `${date("F j", start)} - ${date("F j, Y", end)}`;
  }
  // Different month and year
  if (startYear !== endYear && startMonth !== endMonth) {
    return `${date("F j, Y", start)} - ${date("F j, Y", end)}`;
  }
  // Default (and Same Day)
  return date("F j, Y", start);
}

/**
 * Takes a unix timestamp and returns it as a formatted date
 *
 * @param unixTimestamp
 * @param dateFormat
 * @returns {*}
 */
export function unixToDate(unixTimestamp, dateFormat = 'F j, Y') {
  const theDate = new Date(unixTimestamp * 1000);

  return date(dateFormat, theDate);
}
